<template>
  <div class="nat-record-login page-background-new">
    <div class="nat-record-login-title">核酸报告查询</div>
    <van-form @submit="onSubmit" class="nat-record-login-form">
      <!-- <van-field
        v-model="telphone"
        :rules="[
          {
            required: true,
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '请填写正确的手机号'
          }
        ]"
        type="number"
        placeholder="请输入手机号"
      /> -->
      <van-field
        v-model="idCard"
        :rules="[
          {
            required: true,
            message: '请填写正确的身份证号'
          }
        ]"
        placeholder="请输入身份证号码"
      />
      <van-field v-model="name" placeholder="请输入您的姓名" />
    </van-form>
    <ph-button
      @click="onSubmit"
      class="nat-record-login-commit-button"
      title="确认查询"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      telphone: "",
      verifyCode: "",
      phoneCode: "",
      verifyCodeId: "",
      verifyCodeImage: "",
      countDownTime: 0,
      timer: null,
      idCard: "",
      name: ""
    };
  },
  created() {
    // if (!localStorage.getItem("init")) {
    //   alert("请认真阅读注意事项");
    //   localStorage.setItem("init", true);
    // }
    // this.getVerifyCode();
  },
  methods: {
    bind() {},
    getVerifyCode() {
      this.$http.post(this.$api.USER_VERIFY_CODE, {}).then(res => {
        this.verifyCodeId = res.picId;
        this.verifyCodeImage = res.url;
      });
    },

    onSubmit() {
      // if (!this.$regular.phone(this.telphone)) {
      //   this.$toast("请输入正确的手机号");
      //   return;
      // }
      if (!this.$regular.idCard(this.idCard)) {
        this.$toast("请输入正确的身份证号");
        return;
      }
      if (!this.name) {
        this.$toast("请输入姓名");
        return;
      }
      // this.$http
      //   .post(this.$api.TEST_PATIENT_BYID, {
      //     phone: this.telphone,
      //     idCard: this.idCard
      //   })
      //   .then((res) => {
      //     const list = encodeURIComponent(JSON.stringify(res));
      // });
      this.$router.push({
        name: "nucleic-record-list",
        query: {
          // phone: this.telphone,
          idCard: this.idCard,
          name: this.name
        }
      });
    },
    startCountDown() {
      clearInterval(this.timer);
      this.timer = null;
      this.countDownTime = 60;
      this.timer = setInterval(() => {
        if (this.countDownTime > 0) {
          this.countDownTime -= 1;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    }
  }
};
</script>

<style lang="less">
.nat-record-login {
  // background: @primary-gray;
  &-title {
    margin: 1rem 1rem 0 1rem;
    color: white;
    font-weight: 500;
    line-height: 3rem;
    text-align: center;
    background-color: #09f;
    border-radius: 0.67rem 0.67rem 0 0;
  }
  &-form {
    height: 20rem;
    margin: 0 1rem 0 1rem;
    padding: 0 0.8rem;
    background: white;
    border-radius: 0 0 0.67rem 0.67rem;
    .van-cell {
      padding: 0.6rem 0;
      border-bottom: 1px solid @primary-gray;
      input::-webkit-input-placeholder {
        color: gray;
      }
    }

    .van-cell::after {
      position: relative;
    }

    .van-field__body {
      font-size: 0.94rem;
    }
  }

  &-send-verifycode {
    font-size: 0.8rem;
    line-height: 1.5rem;
  }

  &-commit-button {
    margin: 1rem 1rem 0 1rem;
    line-height: 3rem;
    background-color: #09f;
    border-radius: 1.5rem;
  }

  &-tips {
    margin: 1rem 0.4rem;
    color: red;
    font-size: 0.8rem;
    div {
      color: gray;
    }
  }
}
</style>
